<div [ngClass]="checkBoxClass">
    <nz-checkbox-group 
        [ngClass]="checkBoxClass"
        [(ngModel)]="checkBoxOptions" 
        (ngModelChange)="setAnswer()">
    </nz-checkbox-group>
</div>